import ReactDOM from 'react-dom';

import { App } from '~/App';
import type { AppConfiguration } from '~/models/AppConfiguration';
import { extractTranslations } from '~/utils/translations';

export const render = (rootElement: HTMLElement): void => {
  const { messages } = extractTranslations(rootElement.dataset.jsonAttributes);

  const configuration: AppConfiguration = {
    translatedMessages: messages,
  };

  ReactDOM.render(<App configuration={configuration} />, rootElement);
};
